import React from "react";

export default function Ncloud({ className }) {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="current-color"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={className}
        d="M55.525 21.6667H72.6667C73.4181 21.6667 74.1388 21.9652 74.6701 22.4966C75.2015 23.0279 75.5 23.7486 75.5 24.5V75.5C75.5 76.2515 75.2015 76.9721 74.6701 77.5035C74.1388 78.0348 73.4181 78.3334 72.6667 78.3334H27.3333C26.5819 78.3334 25.8612 78.0348 25.3299 77.5035C24.7985 76.9721 24.5 76.2515 24.5 75.5V52.6917C25.4322 52.7852 26.3785 52.8334 27.3333 52.8334C42.9818 52.8334 55.6667 40.1485 55.6667 24.5C55.6667 23.5452 55.6185 22.5989 55.525 21.6667ZM58.5 61.3334V67H64.1667V61.3334H58.5ZM49.8243 21.6667C50.2567 25.0954 49.8993 28.5776 48.7795 31.847C47.6597 35.1164 45.8072 38.0865 43.3635 40.5302C40.9198 42.9739 37.9498 44.8264 34.6803 45.9462C31.4109 47.066 27.9287 47.4234 24.5 46.991V24.5C24.5 23.7486 24.7985 23.0279 25.3299 22.4966C25.8612 21.9652 26.5819 21.6667 27.3333 21.6667H49.8243V21.6667Z"
      />
    </svg>
  );
}
